import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MatDialogRef,
} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-radicar-solicitud',
  templateUrl: './dialog-radicar-solicitud.component.html',
  styleUrls: ['./dialog-radicar-solicitud.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogRadicarSolicitudComponent {
  onClose(): void {
    this.dialogRef.close();  // Esto cierra el modal o diálogo
  }
  readonly dialogRef = inject(MatDialogRef<DialogRadicarSolicitudComponent>);
}
